import React from "react";
import _ from "lodash";
import { Button } from "reactstrap";
import Socket from "socket";
import tick from "assets/images/sbs/tot-new/tick.png";
import arrow from "assets/images/sbs/tot-new/arrow.png";
import logo from "assets/images/sbs/tot-new/tot-logo.png";
import guesser from "assets/images/sbs/tot-new/guesserr.png";
import clueGiver from "assets/images/sbs/tot-new/clue-giver.png";
import categoryImg from "assets/images/sbs/tot-new/category.png";

const BeforeActionCall = ({
  word,
  roomId,
  isGuesser,
  mobile_app,
  right_words,
  skipped_words,
  category_image,
  guessing_params,
  current_category
}) => {
  const guessed = _.get(guessing_params, "guessed", "Guessed");
  const skip_button = _.get(guessing_params, "skip_button", "SKIP");
  const score_button = _.get(guessing_params, "score_button", "SCORE");
  const skipped_score = _.get(guessing_params, "skipped_score", "Skipped");
  const handleSkip = () => {
    if (mobile_app) {
      const message = {
        action: "skip-tot",
        word
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "skip-tot",
        roomId,
        word
      };
      Socket.sendMessage(data);
    }
  };
  const handleScore = () => {
    if (mobile_app) {
      const message = {
        action: "score-tot",
        word
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "score-tot",
        roomId,
        word
      };
      Socket.sendMessage(data);
    }
  };
  return (
    <div className={`category-screen ${mobile_app ? "mobile-cnt" : "web-cnt"}`}>
      <div className="text-center">
        <img src={logo} alt="logo" className="logo logo-tot" />
        <img
          src={isGuesser ? guesser : clueGiver}
          alt="logo"
          className="guesser"
        />
        <div className="category-box">
          <img src={categoryImg} alt="guesser" className="you-guesser" />
          <h4 className="title">{current_category}</h4>
          {isGuesser ? (
            <div className="skipped-guessed-flex">
              <div className="skipped-circle">
                <p className="txt">{skipped_score}</p>
                <h4 className="skip-num">{skipped_words.length}</h4>
              </div>
              <div className="guessed-circle">
                <p className="txt">{guessed}</p>
                <h4 className="guess-num">{right_words.length}</h4>
              </div>
            </div>
          ) : (
            <div className="category-img-cnt">
              <img src={category_image} alt="" className="category-img" />
            </div>
          )}
          {!isGuesser && <h4 className="word-txt">{word}</h4>}
        </div>
      </div>
      <div className="text-center mx-auto">
        {isGuesser ? (
          <Button
            className={`skip-btn ${
              mobile_app ? "mobile-margin-btn" : "web-margin-btn"
            }`}
            onClick={handleSkip}
          >
            <img src={arrow} className="arrow" alt="" />
            <p className="text">{skip_button}</p>
          </Button>
        ) : (
          <Button
            className={`score-btn ${
              mobile_app ? "mobile-margin-btn" : "web-margin-btn"
            }`}
            onClick={handleScore}
          >
            <img src={tick} className="arrow" alt="" />
            <p className="text">{score_button}</p>
          </Button>
        )}
      </div>
    </div>
  );
};

export default BeforeActionCall;
